import { ButtonCta } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';
import { useFeature } from 'hooks/useFeature';

export const GWPNew_CalloutButton = ({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) => {
  const hideCalloutMessage = useFeature('HIDE_CALLOUT_MESSAGE');
  const t = useTranslate();

  const promoCalloutMessage = !hideCalloutMessage
    ? t('claimYourGiftItems')
    : t('bonusItems');

  return (
    <ButtonCta
      dataTestId="gwp-promo-link"
      className={className}
      onClick={onClick}
      icon="gift"
      size="sm"
      label={promoCalloutMessage}
      variant="secondary"
    />
  );
};
